import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core'
import { MatButton, MatIconButton } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import { MatToolbar } from '@angular/material/toolbar'
import { ElderThemeDirective } from '@elderbyte/ngx-starter'
import { ConstraintInput } from '../../../shopfloor/workcenters/capability/constraints/constraintInput'

import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { ConstraintInputComponent } from '../../../shopfloor/workcenters/capability/constraints/constraint-input/constraint-input.component'

export type WorkItemFilterDialogData = {
  title: string
  constraints: ConstraintInput[]
}

@Component({
  selector: 'app-work-item-filter-dialog',
  imports: [
    MatIcon,
    MatToolbar,
    ElderThemeDirective,
    MatIconButton,
    MatDialogClose,
    ElderTranslatePipe,
    MatButton,
    ConstraintInputComponent,
  ],
  templateUrl: './work-item-constraints-dialog.component.html',
  styleUrl: './work-item-constraints-dialog.component.scss',
})
export class WorkItemConstraintsDialogComponent {
  private dialogRef = inject<MatDialogRef<WorkItemConstraintsDialogComponent>>(MatDialogRef)
  readonly data = inject<WorkItemFilterDialogData>(MAT_DIALOG_DATA)

  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public title = signal<string>('')

  public constraints = signal<ConstraintInput[]>([])

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const data = this.data

    this.title.set(data.title)
    this.constraints.set(data.constraints)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onValueUpdated(changed: ConstraintInput): void {
    const constraintToUpdate = this.constraints().find((conf) => conf.spec.id === changed.spec.id)
    if (!!constraintToUpdate) {
      constraintToUpdate.values = [...changed.values].filter((val) => !!val && val.length > 0)
    }
  }

  public onReset(): void {
    this.constraints().forEach((constraint) => (constraint.values = []))
    this.onSave()
  }

  public onSave(): void {
    this.dialogRef.close(this.constraints())
  }
}
